import React, {
    PureComponent
} from 'react';
import AnimatedView from '../../../components/componentsGeneral/AnimatedView/AnimatedView';
import QuoteShipmentListContainer from '../../../components/componentsControlTower/QuoteShipmentList/QuoteShipmentListContainer';

class ctrlTwrQuoteShipmentListView extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {

        };
    }


    componentDidMount() {

    }

    render() {

        return (
            <AnimatedView>
                <QuoteShipmentListContainer isMobile={this.props.isMobile} warehouseSelection={this.props.warehouseSelection} customerSelection={this.props.customerSelection}/>
            </AnimatedView>

        );
    }
}

export default ctrlTwrQuoteShipmentListView;
